<template>
  <b-container>

    <b-row class="mb-1 w-100 p-0 m-0">
      <b-button class="cls-btn mt-1" block v-b-toggle="'collapse-'+item.id">

        <b-row class="d-flex flex-row justify-content-center align-items-center bg-light item-row m-0 ">

          <b-col lg="6" md="6" sm="12" class="d-flex flex-column justify-content-center align-items-center">
            <b-row>
              <b-col class="d-flex flex-column align-items-center">
                <b-icon icon="arrow-down-short" v-if="item.children.length!==0"/>
              </b-col>
              <b-col class="d-flex flex-row justify-content-center align-items-center">
                <div class="mx-1">
                  <img v-if="isIconImage(item.icon_class)" alt="icon_class" :src="item.icon_class"
                       class="menu_item_icon"/>
                  <b-icon v-else class="ml-2" :icon="item.icon_class"/>
                </div>
                <span class="set-font">{{ item.name }}</span>
              </b-col>
            </b-row>
          </b-col>


          <b-col lg="6" md="6" sm="12" class="d-flex flex-column justify-content-center align-items-center">

            <b-row class="d-flex flex-row justify-content-around align-items-center m-0 w-100">
              <b-col lg="3" md="3" sm="3" cols="12"
                     class="d-flex flex-column justify-content-center align-items-center p-0">
                <b-button class="set-font bg-info m-0 p-1" v-b-modal="'modal-'+item.id">
                  <b-icon class="m-0 p-0" icon="pen"/>
                </b-button>
              </b-col>
              <b-col lg="3" md="3" sm="3" cols="12"
                     class="d-flex flex-column justify-content-center align-items-center p-0">
                <b-button class="set-font bg-danger m-0 p-1" @click="removeItem(item.id)">
                  <b-icon class="m-0 p-0" icon="trash"/>
                </b-button>
              </b-col>
              <b-col lg="3" md="3" sm="3" cols="12"
                     class="d-flex flex-column justify-content-center align-items-center p-0">
                <b-button class="set-font bg-success m-0 p-1" v-b-modal="'modal-add-child'+item.id">
                  <b-icon class="m-0 p-0" icon="plus"/>
                </b-button>
              </b-col>
              <b-col lg="3" md="3" sm="3" cols="12"
                     class="d-flex flex-column justify-content-center align-items-center p-0 d-none">
                <b-form-checkbox @change="showItem(item)" class="p-1 m-0 d-none" value="1" checked="1"
                                 v-if="item.status===1"/>
                <b-form-checkbox @change="showItem(item)" class="p-1 m-0 d-none" v-else/>
              </b-col>
            </b-row>

          </b-col>
        </b-row>

      </b-button>
      <b-collapse :id="'collapse-'+item.id" role="tabpanel" class="w-100">
        <MenuItem v-for="child in item.children" :key="child.id" :item="child"/>
      </b-collapse>
    </b-row>

    <b-modal :id="'modal-'+item.id" :ref="'modal-'+item.id" hide-footer centered @cancel="resetUpdateItem"
             @hide="resetUpdateItem">
      <menu-item-form :item="item" mode="update"/>
    </b-modal>

    <b-modal :id="'modal-add-child'+item.id" hide-footer>
      <menu-item-form :item="item" mode="create_sub_item"/>
    </b-modal>

  </b-container>
</template>

<script>

import {flatMenu} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Menu'
import FormGroup from "../../validator/FormGroup";
import {required, url} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import CreateItemChildModalForm from "./CreateItemChildModalForm";
import MenuItemForm from "@/plugin/components/dashboard/menu/MenuItemForm.vue";

export default {
  name: "MenuItem",
  props: ['item'],
  components: {MenuItemForm, FormGroup, FormErrorsManager, CreateItemChildModalForm},
  data() {
    return {
      editItem: {
        id: parseInt(this.item.id),
        menu_id: parseInt(this.$route.params.id),
        status: this.item.status,
        target: this.item.target,
        order: this.item.order,
        parent_id: this.item.parent_id,
        name: this.item.name,
        url: this.item.url,
        icon_class: this.item.icon_class,
        color: this.item.color,
      }
    }
  },
  validations: {
    editItem: {
      name: {required},
      url: {required, url},
      color: {required},
      order: {required},
    }
  },
  methods: {
    resetUpdateItem() {
      this.editItem = {
        id: parseInt(this.item.id),
        menu_id: this.$route.params.id,
        status: this.item.status,
        target: this.item.target,
        order: this.item.order,
        parent_id: this.item.parent_id,
        name: this.item.name,
        url: this.item.url,
        icon_class: this.item.icon_class,
        color: this.item.color,
      }
    },
    removeItem(itemId) {
      let text = "آیا از حذف آیتم اطمینان دارید؟";
      if (confirm(text) === true) {
        this.$store.dispatch("Menu/deleteItem", {id: itemId, menu_id: this.$route.params.id})
      }
    },
    checkParentId() {
      if (this.editItem.parent_id === null) {
        delete this.editItem.parent_id
      } else {
        this.editItem.parent_id = parseInt(this.editItem.parent_id)
      }

    },
    handleOk() {
      this.checkParentId()
      this.$store.dispatch("Menu/updateItem", this.editItem)
    },
    showItem(item) {
      let editItem = {
        id: parseInt(item.id),
        menu_id: item.menu_id,
        target: item.target,
        order: item.order,
        parent_id: item.parent_id,
        name: item.name,
        url: item.url,
        icon_class: item.icon_class,
        color: item.color,
      }
      editItem.status = item.status !== 1;

      if (item.parent_id === null) {
        delete editItem.parent_id
      } else {
        editItem.parent_id = parseInt(editItem.parent_id)
      }

      this.$store.dispatch("Menu/updateItem", editItem)
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.handleOk()
        this.$nextTick(() => {
          this.$bvModal.hide('modal-' + this.item.id)
          this.resetUpdateItem()
        })
      }
    },
    isIconImage(icon_class) {
      if (icon_class == null) return false
      if (icon_class.indexOf('storage/') > -1) return true
      return false
    },
    removeIcon() {
      if (confirm('آیا از حذف ایکون اطمینان دارید؟')) {
        this.editItem.icon_class = ''
        this.item.icon_class = ''
        this.handleOk();
      }
    }
  }
}
</script>

<style scoped>
.set-font {
  font-size: 12px;
}

.item-row {
  padding: 2px;
  border-radius: 4px;
  border: 1px solid grey;
  margin: 4px 0 4px;
  width: 100%;
  background-color: transparent;
}

.cls-btn {
  padding: 0;
  margin: 0;
  color: black;
  background-color: transparent;
  border: none;
  width: 100%;
}

.cls-btn:hover {
  color: black;
  background-color: transparent;
  border: none;
}

.cls-btn:focus {
  color: black;
  border: 2px solid grey;
}

.menu_item_icon {
  height: 25px;
  width: 25px;
  object-fit: contain;
}

</style>